import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(checkoutReviewAndSubmitHeaderStyles, {
    placeOrderButton: {
        css: css`
            flex-shrink: 0;
            margin-left: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 50%;
                            margin-left: 10px;
                        `,
                        css`
                            width: unset;
                            display: none;
                        `,
                    ],
                    "min",
                )}
        `,
    },
});
